export function getParents(nav, pathname) {

  var parents = [];

  if (!pathname) {
    return parents;
  }

  var pathnames = pathname.split('/');

  var url = '';

  pathnames.forEach(function (path) {

    if (path) {
      url = url + '/' + path;
    } else {
      url = '/';
    }

    if (nav[url] && nav[url].title) {
      parents.push(nav[url]);
    }

    if (url == '/') {
      url = '';
    }
  });

  return parents;
}